import classNames from 'classnames';
import injectSheet from 'react-jss';

import {screenSize} from '-/util/util';
import {important, rem} from '-/styles/utils';

const USE_MOBILE_DIALOG_WIDTH_THRESHOLD = 500;

const styles = () => ({
    root: {
        position: 'fixed',
        zIndex: 999,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        padding: rem(15),
        borderRadius: rem(5),
        background: '#ffffff',
        boxShadow: '0 5px 4px rgba(0, 0, 0, 0.19)',
        maxHeight: '80%',
    },
    background: {
        position: 'fixed',
        zIndex: 999,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'grey',
        opacity: .8
    },
    mobile: {
        width: important('80%')
    }
});

const Dialog = (props) => {
    const {children, dialogCls = '', alertCls = '', classes = {}} = props;
    const fullDialogCls = classNames('alert-container', dialogCls);

    const fullAlertCls = classNames(classes.root, alertCls, {
        [classes.mobile]: screenSize().width < USE_MOBILE_DIALOG_WIDTH_THRESHOLD
    });
    return (
        <div className={fullDialogCls}>
            <div className={classes.background} />
            <div className={fullAlertCls}>
                {children}
            </div>
        </div>
    );
};

export default injectSheet(styles)(Dialog);
